module.exports = __webpack_public_path__ + "static/media/loader.896fc5f1.svg";